module.exports = __webpack_public_path__ + "img/08687c7.png";